import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    loading: false,
    upload_file_visibility: false,
    current_image_type: 'bg',
    bg_image_url: '',
    logo_url: '',
    qr_image_url: '',
    using_defaults: true
  },
  mutations: {
    SET_BRANDING_IMAGES_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_BRANDING_IMAGES_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_BRANDING_IMAGES_DIALOG_CURRENT_IMAGE_TYPE(state, payload) {
      state.current_image_type = payload
    },
    SET_BRANDING_IMAGES_DIALOG_BG_IMAGE_URL(state, payload) {
      state.bg_image_url = payload
    },
    SET_BRANDING_IMAGES_DIALOG_LOGO_URL(state, payload) {
      state.logo_url = payload
    },
    SET_BRANDING_IMAGES_DIALOG_QR_IMAGE_URL(state, payload) {
      state.qr_image_url = payload
    },
    SET_BRANDING_IMAGES_DIALOG_USING_DEFAULTS(state, payload) {
      state.using_defaults = payload
    },

    INIT_BRANDING_IMAGES_DIALOG_UPLOAD_FILE(state) {
      state.upload_file_visibility = true
    },
    RESET_BRANDING_IMAGES_DIALOG_UPLOAD_FILE(state) {
      state.upload_file_visibility = false
    },
    RESET_BRANDING_IMAGES_DIALOG(state) {
      state.visibility = false
    },
    RESET_BRANDING_IMAGES_DIALOG_IMAGES(state) {
      state.bg_image_url = ''
      state.logo_url = ''
      state.qr_image_url = ''
      state.using_defaults = true
    }
  },
  actions: {
    async initBrandingImagesDialog({ commit }) {
      try {
        commit('SET_BRANDING_IMAGES_DIALOG_VISIBILITY', true)
        commit('SET_BRANDING_IMAGES_DIALOG_LOADING', true)
        // clear any previously loaded URLs (possibly from another device) so a
        // failed fetch can't leave stale branding previews/reset controls visible
        commit('RESET_BRANDING_IMAGES_DIALOG_IMAGES')
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''), loading: true })
        const response = await api.getBranding()
        if (response.data.success) {
          commit('SET_BRANDING_IMAGES_DIALOG_BG_IMAGE_URL', response.data.data.bg_image_url)
          commit('SET_BRANDING_IMAGES_DIALOG_LOGO_URL', response.data.data.logo_url)
          commit('SET_BRANDING_IMAGES_DIALOG_QR_IMAGE_URL', response.data.data.qr_image_url)
          commit('SET_BRANDING_IMAGES_DIALOG_USING_DEFAULTS', response.data.data.using_defaults)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_BRANDING_IMAGES_DIALOG_LOADING', false)
      }
    },

    async uploadBrandingImage({ rootState, state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', ''), loading: true })

        const form_data = new FormData()
        form_data.append('device_id', rootState.auth.selected_device)
        form_data.append('image_type', state.current_image_type)
        form_data.append('file', payload.file)

        const response = await api.uploadBrandingImage({ params: form_data })
        if (response.data.success) {
          dispatch('initBrandingImagesDialog')
          commit('RESET_BRANDING_IMAGES_DIALOG_UPLOAD_FILE')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.upload', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },

    async deleteBrandingImage({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.deleting', ''), loading: true })

        const params = { device_id: rootState.auth.selected_device, image_type: payload.image_type }

        const response = await api.deleteBrandingImage({ params: params })
        if (response.data.success) {
          dispatch('initBrandingImagesDialog')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.delete', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
